import { BriefFlow } from '@/app/pages/create-brief-select/flows/flow-chooser/flow-chooser';
import { ChangeDetectionStrategy, Component, output } from '@angular/core';

export type ScreeningFlow = 'ai' | 'wizard';

@Component({
  selector: 'sbs-flow-chooser-screening',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './flow-chooser-screening.html',
  styleUrl: './flow-chooser-screening.scss',
})
export class FlowChooserScreening {
  readonly choose = output<ScreeningFlow>();
}
